export const normalizeIdArray = (value) => {
  if (Array.isArray(value)) {
    return Array.from(
      new Set(
        value
          .flatMap((item) => {
            if (typeof item === 'string') {
              return item.split(',');
            }

            if (item && typeof item === 'object') {
              return [item.id || item.key || item.value || ''];
            }

            return [];
          })
          .map((item) => String(item).trim())
          .filter((item) => item !== '')
      )
    );
  }

  if (typeof value === 'string') {
    return value
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item !== '');
  }

  return [];
};

export const buildLookupMap = (items, labelKey) =>
  (Array.isArray(items) ? items : []).reduce((accumulator, item) => {
    if (!item?.id) {
      return accumulator;
    }

    return {
      ...accumulator,
      [item.id]: item[labelKey] || '',
    };
  }, {});

export const getDisplayValues = (ids, lookupMap) =>
  normalizeIdArray(ids)
    .map((id) => lookupMap[id])
    .filter((value) => Boolean(value && value.trim()));
